import { render } from "./AdvertisingPolicyPage.vue?vue&type=template&id=0ea75806&scoped=true"
import script from "./AdvertisingPolicyPage.vue?vue&type=script&lang=ts"
export * from "./AdvertisingPolicyPage.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-0ea75806"

export default script